/*
 * COPYRIGHT (c) 2024
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import React from 'react';
import { useTranslation } from '@scuf/localization';
import _ from 'lodash';
import { format } from 'date-fns';

import descriptors from '../../../locales/en-US/descriptors';
import { IUtilityMeterBaselineDetails } from '../BaselineConfigurationModels';

import './BaselineQPopupTheme.scss';
export interface IBaselineQualityPopupcontentProps {
  baselineDetails: IUtilityMeterBaselineDetails;
}

const getBaselineQualityIndicator = (quality: string) => {
  return quality === 'good' ? 'show-good' : 'show-poor';
};

export const BaselineQualityPopupContent = (
  props: IBaselineQualityPopupcontentProps
) => {
  const baselineDesc = descriptors.baseline;
  const [t] = useTranslation();
  return (
    <div className="baseline-quality-popup-wrapper">
      <div className="baseline-quality-header">
        {t(baselineDesc.baselineQuality)}
      </div>
      <div className="baseline-quality-content">
        <div className="baseline-quality-content-row">
          <div className="baseline-quality-content-row-label">
            {t(baselineDesc.baselineQuality)}
          </div>
          <div className="baseline-quality-content-row-value">
            <span
              className={`baseline-indicator-icon-wrapper ${getBaselineQualityIndicator(
                _.toLower(props.baselineDetails.quality)
              )}`}
            ></span>
            <span>
              {`${props.baselineDetails.quality} (${props.baselineDetails.qualityDescription})`}
            </span>
          </div>
        </div>
        {props.baselineDetails.metrics.map((metric, index) => {
          return (
            <div
              className="baseline-quality-content-row"
              key={`${metric.name}${index}`}
            >
              <div className="baseline-quality-content-row-label">
                {t(metric.name)}
              </div>
              <div className="baseline-quality-content-row-value">
                <span className="baseline-indicator-icon-wrapper"></span>
                <span>{`${metric.value} ${metric.unit || ''}`}</span>
              </div>
            </div>
          );
        })}
        <div className="baseline-quality-content-row">
          <div className="baseline-quality-content-row-label">
            {t(baselineDesc.baselinePeriod)}
          </div>
          <div className="baseline-quality-content-row-value">
            <span className="baseline-indicator-icon-wrapper"></span>
            <span>
              {`${format(
                props.baselineDetails.baselinePeriodStart,
                'dd MMM yyyy'
              )} - 
            ${format(props.baselineDetails.baselinePeriodEnd, 'dd MMM yyyy')}`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
